module.exports = __webpack_public_path__ + "static/media/pendon-virgen-coromoto-2-small.49bfeef3.jpg";